var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
/* eslint-disable @stencil-community/required-jsdoc */
import { h, getAssetPath, Host } from "@stencil/core";
import { ClickOutside } from "stencil-click-outside";
export class ChSelect {
    constructor() {
        this.name = undefined;
        this.iconSrc = undefined;
        this.arrowIconSrc = undefined;
        this.autoColor = false;
        this.disabled = undefined;
        this.width = undefined;
        this.height = undefined;
        this.toggle = false;
    }
    optionSelected = "";
    arrowTop = getAssetPath(`./select-assets/arrow-top.svg`);
    /**
     * @type EventEmitter
     *
     * Track component events (I.e. activation of dropdown component)
     */
    onToggle;
    /**
     * Emmits the item id
     */
    optionClickedEvent;
    el;
    // test
    optionsContainerEl;
    selectContainerEl;
    selectFlexContainerEl;
    ro;
    componentDidLoad() {
        this.ro = new ResizeObserver(entries => {
            for (const entry of entries) {
                this.calculateSelectWidth(entry.contentBoxSize[0].inlineSize);
                this.calculateSelectHeight();
            }
        });
        this.ro.observe(this.el);
        this.ro.observe(this.optionsContainerEl);
    }
    calculateSelectWidth(width) {
        if (width !== 0) {
            this.selectContainerEl.style.width = width + "px";
        }
    }
    calculateSelectHeight() {
        if (this.height !== "" && this.height) {
            this.selectFlexContainerEl.style.height = this.height;
        }
    }
    handleKeyDown(ev) {
        switch (ev.key) {
            case " ":
                this.toggleComponent();
                break;
            case "ArrowDown" || "ArrowUp":
                // todo
                break;
            default:
                break;
        }
    }
    closeSelect() {
        // close the select when user clicks outside of component area.
        if (this.toggle) {
            this.toggleComponent();
        }
    }
    optionClickedHandler(event) {
        const targetOption = event.currentTarget.id;
        this.toggleComponent();
        this.optionClickedEvent.emit({ "option-value": targetOption });
    }
    /*
     * This will manage the dropdown component event and state changes
     */
    toggleComponent() {
        this.toggle = !this.toggle;
        // When the user click emit the toggle state value
        this.onToggle.emit({ visible: this.toggle });
    }
    resolveIcon() {
        if (this.iconSrc !== undefined) {
            return this.iconSrc;
        }
        return "";
    }
    resolveArrowIcon() {
        if (this.arrowIconSrc !== undefined) {
            return this.arrowIconSrc;
        }
        return this.arrowTop;
    }
    render() {
        return (h(Host, { key: 'eeb8c132ff742b1e9355c27c9bb56270ae25385d', "aria-label": this.name, role: "listbox", "aria-expanded": this.toggle ? "true" : "false", tabindex: "0" }, h("div", { key: '57624e1117bfb4ca102258705ce9b7dc5f6e5add', ref: el => (this.selectContainerEl = el), class: this.toggle
                ? "select-container uncollapsed"
                : "select-container collapsed" }, h("div", { key: '64b7f0c58a6290843efd321069c50979827729d7', class: "list-container", part: "select-box", onClick: () => this.toggleComponent(), ref: el => (this.selectFlexContainerEl = el) }, h("div", { key: '2eb3c2dc77cbc6fdfcb5fb3fe558cd35dc999344', class: "left-container" }, this.iconSrc && (h("span", { key: 'cf2809d490c33bf117061e31f7d4a0d462b43f1f', class: "icon custom-icon" }, h("ch-icon", { key: 'eaa643c09e2c3f94cd050a103644bcb37383efdc', src: this.resolveIcon(), style: {
                "--select-icon-size": "var(--icon-size)",
                "--select-icon-color": `var(--icon-color)`
            } }))), h("span", { key: 'eca0390a7d7923837f15fe988ea0f239195bc7c0', class: "text" }, this.optionSelected ? this.optionSelected : this.name)), h("span", { key: 'd8c3e3a2a85e42061b9ceb353651f0c0c005c5de', class: "icon arrow-icon" }, h("div", { key: '38a49d773c2539fa5226f27a93c0b5dd39df4dbd', part: "collapse-icon" })))), h("div", { key: '3a2febcffb22a4549f09fdab9bf6d03a4a1dab34', ref: el => (this.optionsContainerEl = el), class: this.toggle ? "select-options active" : "select-options inactive", part: "select-options" }, h("slot", { key: '896f394ee6e2e745bdd2055fda7b4a39e11a9454' }))));
    }
    static get is() { return "ch-select"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-select.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-select.css"]
        };
    }
    static get assetsDirs() { return ["select-assets"]; }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "iconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon-src",
                "reflect": false
            },
            "arrowIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "arrow-icon-src",
                "reflect": false
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "false",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the icon will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": false
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "width",
                "reflect": false
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "height",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "toggle": {}
        };
    }
    static get events() {
        return [{
                "method": "onToggle",
                "name": "onToggle",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "type",
                            "text": "EventEmitter * Track component events (I.e. activation of dropdown component)"
                        }],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "optionClickedEvent",
                "name": "optionClickedEvent",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emmits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "handleKeyDown",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "itemClicked",
                "method": "optionClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
__decorate([
    ClickOutside(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ChSelect.prototype, "closeSelect", null);
